import { ref, computed } from 'vue'
import {
  showLoginPopup,
  showVoucherPopup,
} from '@/common/utils/scalable.player'
import { PlayerInterface } from '@/common/utils/player.interface'
import {
  ACTION_DISPLAY,
  ACTION_STATE,
  CONTENT_STATUS,
} from '@/common/utils/action-button/const'
import { useRouterComposable } from '@/common/use/useRouterComposable'
import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'
import cookie from '@/common/utils/cookie'

export const usePlayerActionButton = (streamStatus) => {
  const { pushRouter } = useRouterComposable()
  const isButtonDisabled = ref(false)
  const status = ref(streamStatus)
  const episodeNumber = ref('0')

  const STREAM_DISPLAY = {
    CONTINUE: '이어보기',
    NORMAL: computed(() => `에피소드 ${episodeNumber.value} 보기`),
    LATEST: computed(() => `최신 에피소드 ${episodeNumber.value} 보기`),
    BEGIN: '처음부터 보기',
  }

  /**
   * action 이 stream 일 경우 버튼 디스플레이 상태 반환
   * @param displayState // = STREAM_DISPLAY
   * @returns {string}
   */
  const getStreamButtonDisplay = (displayState = '') => {
    switch (displayState) {
      case CONTENT_STATUS.CONTINUE:
        return STREAM_DISPLAY.CONTINUE

      case CONTENT_STATUS.NORMAL:
        return STREAM_DISPLAY.NORMAL.value

      case CONTENT_STATUS.LATEST:
        return STREAM_DISPLAY.LATEST.value

      case CONTENT_STATUS.BEGIN:
        return STREAM_DISPLAY.BEGIN
    }
  }

  /**
   * action button 초기화 (get permission for content 호출)
   * @param contentInfo
   * @param permission
   * @returns {{display: (string|string), action: string}}
   */
  const getActionButton = ({ contentInfo, permission }) => {
    episodeNumber.value = contentInfo?.episodenumber?.replace('회', '') ?? ''

    try {
      const isWavveOn = cookie.isWavveOn()
      const title = isWavveOn ? '시청하기' : permission?.display ?? ''
      const action = isWavveOn ? ACTION_STATE.STREAM : permission?.action

      const IS_STREAM = action === ACTION_STATE.STREAM

      if (action === ACTION_STATE.MEMO) {
        isButtonDisabled.value = true
      }

      return {
        action,
        display: IS_STREAM ? getStreamButtonDisplay(status.value) : title,
      }
    } catch (e) {
      console.error(`Error Action Button State Info Data :${e.message}`)

      return {
        action: ACTION_STATE.NONE,
        display: ACTION_DISPLAY.DISABLE,
      }
    }
  }

  /**
   * 로그인 팝업 호출
   */
  const actionLogin = () => {
    showLoginPopup()
  }

  /**
   * 구매 팝업 호출
   * @param contentType
   * @param contentInfo
   */
  const actionPurchase = (contentType, contentInfo) => {
    PlayerInterface.pause()
    showVoucherPopup({ type: contentType, contentInfo })
  }

  /**
   * 스트리밍 페이지 이동
   * @param contentType
   * @param landingInfo
   * @param routeQuery
   */
  const actionStream = (contentType, landingInfo, routeQuery) => {
    const query = { ...routeQuery }

    if (contentType === 'vod') {
      const { content_id: contentId = '' } = landingInfo
      Object.assign(query, { contentid: contentId })
    }

    pushRouter({
      name: PATH_NAME_PLAYER_STREAM,
      params: { section: contentType },
      query,
    })
  }

  return {
    isButtonDisabled,
    getActionButton,
    actionLogin,
    actionPurchase,
    actionStream,
  }
}
